<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <v-layout row class="text-xs-left ml-4 mr-2 mb-3">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> qr_code </v-icon>
          </v-avatar>
          {{displayDocumentIDGTypeA(this.getDetail.basic.tag, this.getDetail.basic.idg)}}
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
        v-if="this.getDetailBasic.link === true">
          <v-icon> link </v-icon>
        </v-chip>
        <!-- <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
        v-if="this.getDetailBasic.save === true">
          <v-icon :color="ui.btnColorWarning"> save </v-icon>
        </v-chip> -->
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
        v-if="this.getDetailBasic.lock === true">
          <v-icon :color="ui.btnColorWarning"> lock </v-icon>
        </v-chip>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
        v-if="this.getDetail.basic.tag !== 'G1'">
          {{this.displayDocumentRevTypeA(this.getDetailRev)}}
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> book </v-icon>
          </v-avatar>
          Tag
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{getDetail.basic.tag}}
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2"
      v-if="this.getDetail.basic.tag === 'G1'">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> folder </v-icon>
          </v-avatar>
          Tag Destination
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{getDetail.basic.tagd}}
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2"
      v-if="this.getDetail.basic.tag === 'G1'">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> source </v-icon>
          </v-avatar>
          Tag Source
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{getDetail.basic.tags}}
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2"
      v-if="this.getDetail.basic.tag !== 'G1'">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> bookmark_border </v-icon>
          </v-avatar>
          Type
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{getDetailRev.type}}
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2"
      v-if="this.getDetail.basic.tag !== 'G1'">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> security </v-icon>
          </v-avatar>
          Security
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{getDetailRev.sec}}
        </v-chip>
      </v-layout>
      <v-layout class="text-xs-left ml-4 mr-2"
      v-if="this.getDetail.basic.tag !== 'G1'">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> sync_alt </v-icon>
          </v-avatar>
          Status
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{getDetailRev.stat}}
        </v-chip>
      </v-layout>
      <!-- <v-layout class="text-xs-left ml-4 mr-2"
      v-if="this.getDetail.basic.tag !== 'G1'">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> change_history </v-icon>
          </v-avatar>
          Mods
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{getDetailRev.nmod}}
        </v-chip>
      </v-layout> -->
      <v-layout class="text-xs-left ml-4 mr-2">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          <v-avatar>
          <v-icon> today </v-icon>
          </v-avatar>
          Date
        </v-chip>
        <v-spacer/>
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
          {{dateTypeA(this.getDetailStats.dedit)}}
        </v-chip>
      </v-layout>
      <v-layout row class="mr-2">
        <v-spacer/>
        <StatsReadCard v-if="this.tag !== 'G1'"
        :data="{tag: this.getDetail.basic.tag}"/>
        <StatsReadCardOpen
        :data="{tag: this.getDetail.basic.tag}"
        v-if="
        this.tag === 'U1' ||
        this.tag === 'C1' ||
        this.tag === 'U1'
        "/>
        <RevisionReadCard v-if="this.tag !== 'G1'"/>
        <GetDocumentLogListPage :data="{size: 'icon'}"/>
        <RevisionEdit v-if="this.tag !== 'G1'"/>
        </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import RevisionReadCard from "@/document/revisions/components/RevisionReadCard";
import RevisionEdit from "@/document/revisions/components/RevisionEdit";
import StatsReadCard from "@/support/stats/components/StatsReadCard";
import StatsReadCardOpen from "@/support/stats/components/StatsReadCardOpen";
// import SourceDocReadCard from "@/support/source/components/SourceDocReadCard";
// import GetDocumentRevsListPage from "@/document/revisions/components/GetDocumentRevsListPage";
import GetDocumentLogListPage from "@/document/log/components/GetDocumentLogListPage";
export default {
  mixins: [apptheme, dateFunctions, revFunctions, displayFunctions],
  components: {
    // GetDocumentRevsListPage,
    GetDocumentLogListPage,
    RevisionReadCard,
    // SourceDocReadCard,
    StatsReadCardOpen,
    RevisionEdit,
    StatsReadCard
  },
  computed: {
    ...mapGetters([
      "getDocumentRevsList",
      "getDetail",
      "getDetailRev",
      "getDetailBasic",
      "getDetailStats"
    ]),
    tag() {
      return this.getDetail.basic.tag;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false
    };
  }
};
</script>
